import React from 'react'
import ContentLoader from 'react-content-loader'

export const BusinessUsersRegisteredLoader = ({ className = '' }) => {
    return (
        <ContentLoader height={'98px'} className={className}>
            <rect height={'150px'} width={'100%'} rx={'5px'} ry={'5px'} />
        </ContentLoader>
    )
}
